module.exports = __webpack_public_path__ + "static/media/Fawaz Al-Fraiji.3587c4ea.jpg";